export default {
    'top': {
        target: 'top center',
        popup: 'bottom center'
    },
    'top-left': {
        target: 'top left',
        popup: 'bottom left'
    },
    'top-right': {
        target: 'top right',
        popup: 'bottom right'
    },
    'bottom': {
        target: 'bottom center',
        popup: 'top center'
    },
    'bottom-left': {
        target: 'bottom left',
        popup: 'top left'
    },
    'bottom-right': {
        target: 'bottom right',
        popup: 'top right'
    },
    'left': {
        target: 'middle left',
        popup: 'middle right'
    },
    'left-top': {
        target: 'top left',
        popup: 'top right'
    },
    'left-bottom': {
        target: 'bottom left',
        popup: 'bottom right'
    },
    'right': {
        target: 'middle right',
        popup: 'middle left'
    },
    'right-top': {
        target: 'top right',
        popup: 'top left'
    },
    'right-bottom': {
        target: 'bottom right',
        popup: 'bottom left'
    }
};
